import React from 'react'

import { Tooltip }  from '../tooltip/Tooltip'

const CheckoutSectionHeader = ({ label, toolTip }) => (
    <div className='d-flex'>
         <h4 className="headline headline-sm mb-2">{label}</h4>
         <Tooltip text={toolTip} />
    </div>
   
)

export default  CheckoutSectionHeader
